<template>
  <div class="com-box" :class="{'comBoxMargin': creationMode}">
    <div class="com-title" v-if="creationMode">报名设置</div>
    <div class="com-content" :class="{'comContentMargin': creationMode}">
      <div class="fee-box">
        <van-field 
          v-model="signUpType" 
          label="报名类型" 
          label-align="left" 
          input-align="right" 
          readonly 
          border
          right-icon="arrow" 
          class="signup-type" 
          @click="changeSignupType" 
          placeholder="请选择报名类型" />
      </div>
      <template v-if="isTeacher">
        <div class="field-item van-hairline--bottom">
          <div class="field-item-title">
            <span>报名成功短信设置</span>
          </div>
          <van-switch 
            v-model="form.boolSmsSet" 
            size="24px" 
            active-color="#FF6B31" 
            inactive-color="#f4f4f4"
            @change="onFormChange"
          />
        </div>
        <van-field
          v-if="form.boolSmsSet"
          v-model="form.smsText"
          rows="1"
          autosize
          type="textarea"
          placeholder="请输入报名成功的短信内容"
          :maxlength="184"
          @blur="onFormChange"
        />
      </template>
      <van-collapse v-model="activeNames">
        <van-collapse-item title="顾客报名字段设置" name="fieldsConf" class="collapse-item">
          <!-- <div class="field-item van-hairline--bottom">
            <div class="field-item-title">
              <van-image width="20" height="20" :src="icons.title"/>
              <span>活动标题</span>
            </div>
            <van-switch 
              v-model="form.boolShowTitle" 
              size="24px" 
              active-color="#FF6B31" 
              inactive-color="#f4f4f4" 
              disabled />
          </div>
          <div class="field-item van-hairline--bottom">
            <div class="field-item-title">
              <van-image width="20" height="20" :src="icons.money"/>
              <span>活动金额</span>
            </div>
            <van-switch v-model="form.boolShowAmount" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4" disabled />
          </div> -->


          <div class="field-item van-hairline--bottom">
            <div class="field-item-title">
              <van-image width="20" height="20" :src="icons.user"/>
              <span>姓名</span>
            </div>
            <!-- <van-switch v-model="form.boolShowUsername" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4" disabled /> -->
          </div>
          <div class="field-item van-hairline--bottom">
            <div class="field-item-title">
              <van-image width="20" height="20" :src="icons.phone"/>
              <span>手机号</span>
            </div>
            <!-- <van-switch v-model="form.boolShowPhone" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4" disabled /> -->
          </div>
          <div class="field-item">
            <div class="field-item-title">
              <van-image width="20" height="20" :src="icons.ver"/>
              <span>验证码</span>
            </div>
            <!-- <van-switch 
              v-model="form.boolShowCode" 
              size="24px" 
              active-color="#FF6B31" 
              inactive-color="#f4f4f4"
              disabled /> -->
          </div>
          <template v-if="form.customField">
            <div class="field-box" v-for="(item,index) in form.customField" :key="index">
              <van-field placeholder="请输入" :maxlength="6" v-model="item.fieldKey" @blur="onFormChange"/>
            </div>
            <div class="btn-box" v-if="form.customField.length < 3" @click="addField">添加字段</div>
            <div class="btn-box" v-if="form.customField.length" @click="delField">删除字段</div>
          </template>
        </van-collapse-item>
      </van-collapse>
      <div class="fee-box">
        <van-field 
          class="fee-label fee-input" 
          :maxlength="5"
          v-model="form.signUpfeeLabel" 
          placeholder="报名项目" 
          @blur="onFormChange"/>
        <van-field class="fee-value fee-input"
          v-if="!userInfo.countAuthority"
          v-model="form.signUpfee" 
          placeholder="报名金额(两位小数)" 
          type="number"
          :readonly="otherConf.isModifying"
          @blur="checkFeeValid">
          <span slot="right-icon">元</span>
        </van-field>
      </div>
    </div>
    <div class="tips" v-if="!userInfo.countAuthority">
      "0"或不填写代表当前活动免费
    </div>
    <van-action-sheet
      v-model="isShowSignupType"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      @select="selectSignupType"
      get-container="body" 
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {round2Places} from '@/utils/utils'
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Object,
    otherConf: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.initForm(newVal);
        }
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    ...mapGetters([
      'isTeacher',
      'isDistributor',
      'isShopowner',
      'isGuide',
      'userInfo'
    ]),
    // 组件创建方式
    creationMode() {
      return this.$route.query.creationMode != 'new' ? true : false
    }
  },
  data() {
    return {
      icons: {
        title: require('@/assets/icons/list_titile.png'),
        phone: require('@/assets/icons/list_phone.png'),
        money: require('@/assets/icons/list_money.png'),
        user: require('@/assets/icons/list_user.png'),
        ver: require('@/assets/icons/list_ver.png'),
      },
      activeNames: ['fieldsConf'],
      form: {
        // boolShowTitle: true,
        // boolShowAmount: true,
        boolShowUsername: true,
        boolShowPhone: true,
        boolShowCode: true,
        signUpfeeLabel: '',
        signUpfee: '',
        signUpType: '',
        boolSmsSet: false,
        smsText: '',
        customField: []
      },
      signUpType: "",
      isShowSignupType: false,
      actions:[{name: '普通报名',type: 1},{name:'自动核销报名', type: 2}],
    }
  },
  mounted() {
    this.getAutoVerification()
  },
  methods: {
    changeSignupType() {
      if (this.$route.query.from != 'manager') {
        this.isShowSignupType = true
      }
    },
    selectSignupType(e) {
      this.form.signUpType = e.type
      this.signUpType = e.name
      this.$emit('change', this.form);
    },
    initForm(val) {
      if (val) {
        this.form = {...val};
        if (this.form.signUpType) {
          this.signUpType = this.form.signUpType == 1 ? '普通报名' : '自动核销报名'
        }
      }
    },
    addField() {
      this.form.customField.push({fieldKey:'',fieldValue: ''})
      this.$emit('change', this.form);
    },
    delField() {
      this.form.customField.splice(this.form.customField.length -1, 1)
      this.$emit('change', this.form);
    },
    onFormChange() {
      this.$emit('change', this.form);
    },
    checkFeeValid() {
      if (this.form.signUpfee < 0) {
        this.form.signUpfee = '';
      }
      this.form.signUpfee = round2Places(this.form.signUpfee);
      this.onFormChange();
    },
    paramesVerify() {
      let isPass = true
      if (this.form.customField.length) {
        this.$toast('请输入报名自定义字段')
        isPass = false
      }
      return isPass
    },
    async getAutoVerification() {
      const res = await this.$api.verification.getAutoVerification()
      this.actions[1].disabled = !res.data
    }
    
  }
}
</script>

<style lang="stylus" scoped>
.com-box
  // margin 15px 0
  .com-title
    padding 0 15px
    font-size 14px
    font-weight bold
    color #303133
  .com-content
    // margin 10px 15px
    padding 15px
    background-color: #fff
    border-radius: 8px
    .field-item
      display: flex
      justify-content: space-between
      align-items: center
      padding 5px 0
      &-title
        color #606266
        display: flex
        align-items: center
        >>> .van-image
          margin-right 5px
    .field-box {
      padding: 0 10px;
      border-bottom: 1px solid #ebedf0;
    }
    .btn-box {
      margin-top: 6px;
      padding 2px 0
      text-align: center
      color $mainTextColor
      font-size 14px
      font-weight 600
      border 1px solid $mainTextColor
      border-radius 8px
    }
    .collapse-item
      >>> .van-collapse-item__content
        padding 12px 0
      >>> .van-cell
        padding 10px 0
        color #646566
    .fee-input
      padding 10px 7px
      >>> .van-field__body
        input
          color $mainTextColor
          border-bottom: 1px solid #ebedf0
        .van-field__right-icon
          padding-right 0
      &::before
        left -2px
        bottom 7px
      &::after
        border-bottom: none
    .fee-box
      display: flex
      align-items: center
      .fee-label
        flex 1
      .fee-value
        flex 1
        >>> .van-cell__value input
          text-align: center
      .signup-type
        padding: 10px 0;

  .tips
    padding-right 15px
    font-size 12px
    color #bbb
    text-align: right
.comBoxMargin {
  margin: 15px 0;
}
.comContentMargin {
  margin: 10px 15px;
}
</style>